import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import axios from 'axios';
import $ from 'jquery';
import Select from 'react-select';
const ViewUnit = (props) => {

    const [items, setitems] = useState([]);
    const url = process.env.REACT_APP_APIURL + "FramUnit/GetFramunitSuper"//?companyid="+props.companyid;
    const [typevalue, settypevalue] = useState();
    const [type, settype] = useState([])
    useEffect(() => {
        fetchUsertype();
    }, [])
    async function fetchUsertype() {

        var res = await axios.get(process.env.REACT_APP_APIURL + "Company/GetCompanies")

        var type = [];
        res.data.map((u) => {
            type.push({ value: u.company_id, label: u.name });
        })
        settype(type)
    }
    useEffect(() => {
        setTimeout(() => {
            $('#example3').DataTable().destroy()
            populatedata()
        },100)
        
    }, []);
    useEffect(() => {
        $('#example3').DataTable();
    }, [items]);
    async function populatedata() {
        await fetch(url).then(res => res.json()).then(result =>
            setitems(result)
        );
    }
     async function deletedata(id) {
         const urldelete = process.env.REACT_APP_APIURL + 'FramUnit/DeleteFramUnit?unitid='+id;
         let res = await axios.post(urldelete);
         if (res.status == 200) {
             swal({
                 title: "Deleted Successfully",
                 icon: "success"
             })
             populatedata();

         }
    }

    async function handleEdit(id) {
        const url = process.env.REACT_APP_APIURL + "FramUnit/GetFramUnit?unitid=" + id + "&companyid=" + props.companyid;
        await fetch(url).then(res => res.json()).then(result => {
            setupdateitems({ ...updateitems, UnitId: result.unitId, UnitName: result.unitName, Amount: result.amount, company_id: result.company_id, description: result.description, MainimageName: result.mainimageName, MainimageUrl: result.mainimageUrl, bedno: result.bedno, farmno: result.farmno, usertypeid: result.company_id })
            settypevalue({ value: result.Company_id, label: result.companyName})
        });
        $("#myModal").modal('show');
    }
    function handleDelete(id) {
        swal({
            title: "Are you sure?",
            //  text: "Once deleted, you will not be able to recover this imaginary file!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete)
            {
                deletedata(id);
              
            } else {
                swal("0 Rows deleted");
            }
        });
    }
    //////////////////////////////////////////////////
   ///////////////update unit//////////////////////// 
    //////////////////////////////////////////////////  
    const [updateitems, setupdateitems] = useState({ UnitId: "", UnitName: "", Amount: 0, company_id: "", description: "", MainimageName: "", MainimageUrl: "", bedno: "", farmno: "", usertypeid: "" })

    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setupdateitems({ ...updateitems, [name]: value })
    }
    const refresh = () => {
        settypevalue(null);
        setupdateitems({ ...updateitems, UnitId: "", UnitName: "", Amount: 0, company_id: "", MainimageName: "", MainimageUrl: "", bedno: "", usertypeid: "", farmno: "" });
    }
    const savemethod = async (data) => {
        debugger;
        //data.companyid = typevalue.value;
        //data.company_id = typevalue.value;
        const url = process.env.REACT_APP_APIURL + "FramUnit/UpdateFramUnit";
        await fetch(url, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status == 200) {
                swal({
                    title: "Saved Successfully",
                    icon: "success"
                })
                refresh();
                populatedata();
                $("#myModal").modal("hide")
            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        savemethod(updateitems);
    }
    return (
        <div className="row">
            <div className="col-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-0">View Farm Unit List</h3>
                    </div>
                    <div className="card-body">

                        <div className="table-responsive">
                            <table id="example3" className="display" data-page-length='50'>
                                <thead>
                                    <tr>
                                        <th>Unit Name</th>
                                        <th>Farm No</th>
                                        <th>Description</th>
                                            <th>Company Name</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map(item =>
                                        <tr key={item.unitId}>
                                            <td>{item.unitName}</td>
                                            <td>{item.farmno}</td>
                                            <td>{item.description}</td>
                                            <td>{item.companyName}</td>
                                            <td>
                                                <span className="d-flex">
                                                    <button href="#" className="btn btn-primary shadow btn-xs sharp me-2"
                                                        onClick={(id) => handleEdit(item.unitId)}>
                                                        <i className="fas fa-pencil-alt"></i>
                                                    </button>
                                                    <button href="#" className="btn btn-danger shadow btn-xs sharp"
                                                        onClick={(id) => handleDelete(item.unitId)}>
                                                        <i className="fa fa-trash"></i>
                                                    </button>
                                                </span>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div id="myModal" className="modal fade " tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="me-auto mb-5 mt-5 text-center mx-auto">Update Farm Unit</h3>
                            </div>
                            <div className="card-body">
                                <div className="basic-form">
                                    <form action="" onSubmit={handleSubmit}>
                                        <div className="row flex-column align-items-center">
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Unit Name</label>
                                                <input type="text" autoComplete="off" className="form-control" name="UnitName" value={updateitems.UnitName} onChange={handleInput} required />
                                            </div>
                                            {/*<div className="mb-3 col-sm-6">*/}
                                            {/*    <label className="form-label">Amount</label>*/}
                                            {/*    <input type="number" autoComplete="off" className="form-control" name="Amount" value={updateitems.Amount} onChange={handleInput} required />*/}
                                            {/*</div>*/}
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">No. of Beds</label>
                                                <input type="number" autoComplete="off" className="form-control" name="bedno" value={updateitems.bedno} onChange={handleInput} required />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Comapany Name *</label>
                                                <Select options={type} value={typevalue} onChange={(e) => { settypevalue(e); setupdateitems({ ...updateitems, company_id: e.value }) }} />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Description</label>
                                                <textarea maxLength="500" rows="3" autoComplete="off" className="form-control" name="description" value={updateitems.description} onChange={handleInput} required />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">No. of Beds</label>
                                                <input type="text" autoComplete="off" className="form-control" name="farmno" value={updateitems.farmno} onChange={handleInput} required />
                                            </div>
                                        </div>
                                        <button type="submit" className="btn btn-primary">Save</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewUnit;